import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import RequireAuth from "@/components/RequireAuth";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import TwoFactorProvider from "@/components/TwoFactorProvider";
import Dashboard from "@/pages/app/Dashboard";
import Leads from "@/pages/app/Leads";
import LeadDetail from "@/pages/app/LeadDetail";
import Quotes from "@/pages/app/Quotes";
import QuoteDetail from "@/pages/app/QuoteDetail";
import PRDs from "@/pages/app/PRDs";
import PRDDetail from "@/pages/app/PRDDetail";
import Clients from "@/pages/app/Clients";
import ClientDetail from "@/pages/app/ClientDetail";
import Agents from "@/pages/app/Agents";
import MemographPage from "@/pages/app/MemographPage";
import Governance from "@/pages/app/Governance";
import Integrations from "@/pages/app/Integrations";
import Settings from "@/pages/app/Settings";
import { Toaster } from "@/components/ui/sonner";

function RootRedirect() {
  const { isAuthenticated, ready } = useAuth();
  if (!ready) return null;
  return <Navigate to={isAuthenticated ? "/app" : "/login"} replace />;
}

function App() {
  return (
    <div className="min-h-screen bg-[#050505] text-[#EDEDED] font-body">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <TwoFactorProvider>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/app"
                element={
                  <RequireAuth>
                    <AppLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<Leads />} />
                <Route path="leads/:id" element={<LeadDetail />} />
                <Route path="quotes" element={<Quotes />} />
                <Route path="quotes/:id" element={<QuoteDetail />} />
                <Route path="prds" element={<PRDs />} />
                <Route path="prds/:id" element={<PRDDetail />} />
                <Route path="clients" element={<Clients />} />
                <Route path="clients/:id" element={<ClientDetail />} />
                <Route path="agents" element={<Agents />} />
                <Route path="memograph" element={<MemographPage />} />
                <Route path="governance" element={<Governance />} />
                <Route path="integrations" element={<Integrations />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "var(--toast-bg)",
                  border: "1px solid var(--toast-border)",
                  borderRadius: 0,
                  color: "var(--toast-color)",
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "12px",
                },
              }}
            />
            </TwoFactorProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
